// extracted by mini-css-extract-plugin
var _1 = "EKTL9moKCa7lfXHayrJe";
var _2 = "zhrvsbiXXAyvyo87OaiB";
var _3 = "rKBS8CVdW5ZCF1etwrDM";
var _4 = "jENT35MFCdBd6AAhftLf";
var _5 = "gJMo5fk0t6LfPqICJP6g";
var _6 = "cKedQ2PSHPYy368hvGxh";
var _7 = "ynWwiwVHvww3pMVFjxPK";
var _8 = "_d6D2SvV3BLDtUCPcMSQ";
var _9 = "FybwSL0KcbrZWKr2KNvR";
var _a = "GnS1R5PKnoqeu5LC4ADi";
export { _1 as "birthday", _2 as "greeting-container", _3 as "greeting-container-space-below", _4 as "guest-greeting", _5 as "guest-header", _6 as "heading", _7 as "identity", _8 as "name", _9 as "oppijanumero", _a as "subtitle" }
